/**
 * @author Ariel
 * @date 2021-06-02
 * @desc 列表页配置
 */
import React from 'react'
import {component_tool} from '../../../../../tool';
import moment from "moment";
import ApplyPlanCol from '../applyPlanCol'

let {WizModal, WizRow, WizCol,WizDatePicker} = component_tool;
let componentName = 'applyPlan'

const columns = (applyId, onDo) => {
  return [
    {
      name: 'id',
      formItem: {type: 'hidden'}
    },
    {
      name: 'applyId',
      formItem: {type: 'hidden', initialValue: applyId}
    },
    {
      name: 'type',
      formItem: {type: 'hidden', initialValue: 0}
    },
    {
      title: '计划安排名称',
      name: 'name',
      tableItem: {},
      searchItem: {},
    },
    {
      title: '安排类型',
      name: 'type',
      tableItem: {
        render: (text, record) => {
          return "公共"
        }
      },
    },
    {
      title: '计划安排时间',
      name: 'planTime',
      tableItem: {
        render: (text, record) => {
          let {startTime, endTime} = record
          let value = startTime + ' ~ ' + endTime
          return <div>{value}</div>
        }
      },
    },
    {
      title: '地址',
      name: 'address',
      tableItem: {},
    },
    {
      title: '限制人数',
      name: 'limitCount',
      tableItem: {
        render: (text, record) => {
          if (text < 0) {
            text = '不限制'
          }
          return text
        }
      },
    },
    {
      title: '报名通过人数',
      name: 'passNumber',
      tableItem: {},
    },
    {
      title: '安排状态',
      name: 'state',
      searchItem: {
        type: 'select'
      },
      tableItem: {},
      dict: [
        {code: 1, codeName: '有效'},
        {code: 0, codeName: '无效'},
      ],
    },
  ]
};

const templateConfig = (e) => {
  let {applyId, onDo} = e
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(applyId, onDo),
        btnAccessCheck: false,
        searchBarProps: {
          buttonSort: ['add'],
          buttons: [
            {
              key: 'add',
              custom: true,
              params: { icon: 'plus', children: '新增计划安排', type: 'primary'},
              customOnClick: {
                key: 'modal',
                params: {
                  modalParams: {
                    title: '添加计划安排',
                    footer: null,
                    destroyOnClose: true,
                    diy: (e) => {
                      return <>
                        <ApplyPlanCol applyId={applyId} changeModal={e.changeModal} type={0}/>
                      </>
                    },
                    width: 750
                  }
                }
              }
            }
          ],
          collapse: false
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: ['update', 'enableOrDisable', 'delete'],
        rowOperateView: [
          {
            key: 'update',
            custom: true,
            params: {  children: '编辑'},
            customOnClick:{
              key: 'modal',
              params: {
                modalParams: {
                  title: '编辑计划安排',
                  footer: null,
                  destroyOnClose: true,
                  diy: (e) => {
                    return <>
                      <ApplyPlanCol applyId={applyId} changeModal={e.changeModal} type={0} record={e.record}/>
                    </>
                  },
                  width: 750
                }
              }
            }
          },
          {
            key: "enableOrDisable",
            custom: true,
            params: {children: "有效"},
            textFormat: {
              recordKey: 'state',
              dirt: {'1': '禁用', '0': '启用',}
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "enable",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${
                  record['state'] === 0 ? "启用" : "禁用"
                }该计划安排吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      state: record['state'] === 0 ? 1 : 0,
                      id: record['id'],
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: "delete",
            custom: true,
            params: {children: "删除"},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "delete",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = '删除后数据不可恢复，您确定要删除选中的安排吗？'
                let ids = [];
                if (record) {
                  ids.push(record.id)
                }
                if (record && record.applyNumber > 0) {
                  wizNotice.error("该计划安排已有报名人员，不能删除")
                } else {
                  WizModal.confirm({
                    title: '注意', content,
                    onOk: () => {
                      callback && callback({
                        ids
                      })
                    },
                    onCancel() {
                    }
                  });
                }
                return null
              }
            },
          },
        ],
        commonOperate: {
          add: true,
          delete: true,
          update: true,
          enable: true
        }
      }
    }
  }
};

const apis = (applyId = [], onDo) => {
  // let {planTime} = onDo.state
  // let value = Object.assign([], planTime)
  // if (planTime && planTime.length === 2) {
  //   value['startTime'] = moment(planTime[0]).format("YYYY-MM-DD HH:mm") + ':00';
  //   value['endTime'] = moment(planTime[1]).format("YYYY-MM-DD HH:mm") + ':59';
  // }
  // log.info("tttt:",value)
  return {
    list: {
      path: `${componentName}/planPageList`,
      payload: {
        key: `${componentName}@planPageList`,
        apiParams: {applyId: applyId}
      }
    },
    add: {
      path: `${componentName}/addPlan`,
      payload: {
        key: `${componentName}@addPlan`,
        apiParams: {}
      }
    },
    update: {
      path: `${componentName}/updatePlan`,
      payload: {
        key: `${componentName}@updatePlan`,
        apiParams: {}
      }
    },
    enable: {
      path: `${componentName}/enablePlan`,
      payload: {
        key: `${componentName}@enablePlan`,
        apiParams: {}
      }
    },
    delete: {
      path: `${componentName}/deletePlan`,
      payload: {
        key: `${componentName}@deletePlan`,
        apiParams: {}
      }
    }
  }
}

let reduxTemplateConfig = (args) => {
  let {applyId, onDo} = args
  return {
    apis: apis(applyId, onDo),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
